/* Members Early Access — countdown, scroll reveal, pre-submit email check.
   Ported from the Claude Design project's members-early-access.js.

   The source script hijacked the form submit and faked a success state. Here
   the form is a real Shopify {% form 'customer' %} that must actually POST,
   so the handler only blocks obviously-malformed addresses and otherwise
   gets out of the way. Success is rendered server-side after the redirect. */
(function () {
  'use strict';

  /* ---------- countdown ---------- */
  function initCount(el) {
    var openAt = new Date(el.dataset.open).getTime();
    /* An unparseable or missing date would render NaN in every cell. Drop the
       whole block instead — the page reads fine without it. */
    if (!openAt || isNaN(openAt)) {
      el.hidden = true;
      return;
    }

    var label = el.querySelector('.ea-count-label');
    var openText = el.dataset.openLabel || 'Your access is open now';
    var prev = {};

    function set(unit, value) {
      var node = el.querySelector('[data-u="' + unit + '"]');
      if (!node) return;
      var s = String(Math.max(0, value)).padStart(2, '0');
      if (prev[unit] === s) return;
      prev[unit] = s;
      node.textContent = s;
      node.classList.remove('tick');
      void node.offsetWidth; /* reflow, so the animation restarts */
      node.classList.add('tick');
    }

    (function tick() {
      var d = openAt - Date.now();
      if (d <= 0) {
        el.classList.add('is-open');
        if (label) label.textContent = openText;
        return;
      }
      set('d', Math.floor(d / 864e5));
      set('h', Math.floor(d / 36e5) % 24);
      set('m', Math.floor(d / 6e4) % 60);
      set('s', Math.floor(d / 1e3) % 60);
      requestAnimationFrame(function () { setTimeout(tick, 250); });
    })();
  }

  /* ---------- capture form ---------- */
  function initForm(form) {
    var input = form.querySelector('.ea-input');
    var note = form.querySelector('.ea-capture-note');
    if (!input || !note) return;

    var original = note.textContent;
    var workerUrl = (form.dataset.workerUrl || '').replace(/\/+$/, '');
    var submitting = false;

    function fail(message) {
      form.classList.add('is-bad');
      input.setAttribute('aria-invalid', 'true');
      note.textContent = message;
      note.classList.add('ea-capture-note--bad');
      input.focus();
    }

    /* Mirrors the server-rendered success state so both paths look identical. */
    function succeed() {
      var title = form.querySelector('.ea-capture-title');
      var row = form.querySelector('.ea-capture-row');
      if (row) row.remove();
      if (title) {
        title.textContent = form.dataset.successTitle || 'You are on the list.';
        title.setAttribute('tabindex', '-1');
        title.focus();
      }
      note.textContent = form.dataset.successNote || 'Watch your inbox.';
      note.classList.remove('ea-capture-note--bad');
      form.classList.add('is-done');
    }

    form.addEventListener('submit', function (e) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim())) {
        e.preventDefault();
        fail('That address does not look right. Try again.');
        return;
      }

      form.classList.remove('is-bad');
      input.removeAttribute('aria-invalid');
      note.textContent = original;
      note.classList.remove('ea-capture-note--bad');

      /* No worker configured: let Shopify have the native POST. That still
         subscribes everyone, it just cannot tag an existing customer. */
      if (!workerUrl || submitting) return;

      e.preventDefault();
      submitting = true;

      var honeypot = form.querySelector('[name="company"]');
      fetch(workerUrl + '/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: input.value.trim(),
          company: honeypot ? honeypot.value : ''
        })
      })
        .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
        .then(function (data) {
          if (!data || !data.ok) return Promise.reject('not_ok');
          succeed();
        })
        .catch(function () {
          /* A failed worker must never cost a signup. Hand the visitor back
             to Shopify's own form rather than showing an error — worst case
             they land subscribed but untagged, which beats losing them. */
          submitting = false;
          form.submit();
        });
    });

    input.addEventListener('input', function () {
      if (!form.classList.contains('is-bad')) return;
      form.classList.remove('is-bad');
      input.removeAttribute('aria-invalid');
      note.textContent = original;
      note.classList.remove('ea-capture-note--bad');
    });
  }

  /* ---------- scroll reveal ---------- */
  function initReveal(nodes) {
    if (!('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: .12 });

    nodes.forEach(function (n) {
      /* Anything already in view on load should not wait for a scroll that
         may never come on a short viewport. */
      if (n.getBoundingClientRect().top < window.innerHeight) n.classList.add('is-in');
      else io.observe(n);
    });
  }

  function boot(root) {
    var scope = root || document;
    var count = scope.querySelector('.ea-count');
    if (count) initCount(count);

    var form = scope.querySelector('.ea-capture');
    if (form) initForm(form);

    initReveal(Array.prototype.slice.call(scope.querySelectorAll('.ea-r')));
  }

  boot(document);

  /* The theme editor tears down and re-renders the section on every settings
     change, which drops the observers and stops the countdown. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('.ea')) boot(e.target);
  });
})();
